<template>
  <div class="speakol-tamplate">
    <table>
      <tr>
          <th>Component Name</th>
          <th>Design</th>
      </tr>
      <tr>
          <td>SpeakolMainButton</td>
          <td><SpeakolMainButton/></td>
      </tr>
    </table>
  </div>
</template>

<script>
import SpeakolMainButton from '@/components/speakol-template/SpeakolMainButton.vue'

export default {
  data () {
    return {
      
    }
  },
  components: {
    SpeakolMainButton
  },
  methods: {
      
  }
}
</script>

<style lang="scss">
.speakol-tamplate {
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid #ddd;
    text-align: left;
    padding: 8px;
  }
}
</style>

